export const getPercentValue = (ratio: number) =>
  Math.round(Math.min(Math.max(ratio * 100, 0), 100))
